/* Loon'r: "ship my pairs together" cart checkbox (snippets/loonr-cart-ship-together.liquid).
   Writes cart attribute "Ship together" = "Yes" / "" via /cart/update.js. Delegated so it
   survives drawer refreshes and in-place cart re-renders. Clears a stale "Yes" when the
   cart drops below 2 pairs (the snippet leaves a [data-loonr-ship-together-clear] marker). */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var clearing = false;
  function setAttr(value) {
    return fetch(root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ attributes: { "Ship together": value } })
    }).then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); });
  }
  document.addEventListener("change", function (ev) {
    var box = ev.target;
    if (!box || !box.matches || !box.matches("[data-loonr-ship-together-input]")) return;
    var wrap = box.closest("[data-loonr-ship-together]");
    var msg = wrap && wrap.querySelector("[data-loonr-ship-together-msg]");
    box.disabled = true;
    setAttr(box.checked ? "Yes" : "").then(function () {
      if (msg) msg.textContent = box.checked ? "Got it. One box for the whole flock." : "";
    }).catch(function () {
      box.checked = !box.checked;
      if (msg) msg.textContent = "That didn't save. Try again?";
    }).then(function () { box.disabled = false; });
  });
  function clearIfStale() {
    if (clearing || !document.querySelector("[data-loonr-ship-together-clear]")) return;
    clearing = true;
    setAttr("").catch(function () {}).then(function () {
      Array.prototype.forEach.call(document.querySelectorAll("[data-loonr-ship-together-clear]"), function (el) { el.remove(); });
      clearing = false;
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", clearIfStale); else clearIfStale();
  new MutationObserver(clearIfStale).observe(document.documentElement, { childList: true, subtree: true });
})();
